import { Text } from '@sitecore-jss/sitecore-jss-nextjs';
import { useRouter } from 'next/router';
import { RegisterMergeText } from '../RegistrationMergeFields';
import { useSitecoreContext, NextImage } from '@sitecore-jss/sitecore-jss-nextjs';
import { StExploreYourProfileWrapper } from './ExploreProfile.stye';
import ButtonPrimary from '../../shared/Button/PrimaryButton';
import UiText from '../../shared/Typography/UiText';
import { Grid, Stack } from '@mui/material';

export type IIcon = {
  value: IValue;
};
export type ICtaButton = {
  value: IValue;
};
export type IValue = {
  href?: string;
  text?: string;
  anchor?: string;
  linktype?: string;
  class?: string;
  title?: string;
  target?: string;
  querystring?: string;
  id?: string;
  src?: string;
  alt?: string;
  width?: string;
  height?: string;
};
export type IHeading = {
  value: string;
};
export type IExploreProfileField = {
  ctaButton: ICtaButton;
  heading: IHeading;
  icon: IIcon;
};

interface IExploreProfile {
  fields: IExploreProfileField;
}
const ExploreProfile: React.FC<IExploreProfile> = (props) => {
  const { sitecoreContext } = useSitecoreContext();
  const siteSettings: any = sitecoreContext?.siteSettings;
  const myProfileUrl: string =
    props?.fields?.ctaButton?.value?.href || siteSettings?.myProfileItemUrl?.value?.href || '';
  const heading = props?.fields?.heading || '';
  const ctaButton = props?.fields?.ctaButton?.value?.text || '';
  const router = useRouter();
  const includeIcon = !!props?.fields?.icon?.value?.src;

  return (
    <Grid container justifyContent="center">
      <Grid item xs={12} md={6} lg={4}>
        <StExploreYourProfileWrapper id="explore-profile" className="ui-explore-profile">
          <Grid container justifyContent="space-evenly">
            {includeIcon && (
              <Grid item sx="auto">
                <NextImage field={props.fields.icon} height={122} width={93} />
              </Grid>
            )}
            <Grid sx={12} lg={includeIcon ? 7 : 12}>
              <Stack
                justifyContent="space-between"
                alignItems={{ xs: 'center', md: includeIcon ? 'flex-start' : 'center' }}
                spacing={2}
                sx={{ height: '100%' }}
              >
                <div></div>
                <UiText className="subtitle">
                  <RegisterMergeText field={heading} data-testid="explore-profile-title" />
                </UiText>
                <div>
                  <ButtonPrimary
                    data-testid="explore-profile-button-id"
                    id="explore-profile"
                    onClick={() => router.push(myProfileUrl)}
                  >
                    <Text field={{ value: ctaButton }} />
                  </ButtonPrimary>
                </div>
              </Stack>
            </Grid>
          </Grid>
        </StExploreYourProfileWrapper>
      </Grid>
    </Grid>
  );
};

export default ExploreProfile;
